<template>
    <div class="container has-text-left">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <b-select v-model="objectTypeId">
                        <option v-for="objectType in optionsForObjectTypes"
                                :key="objectType.id"
                                :value="objectType.id"
                        >{{objectType.name}}
                        </option>
                    </b-select>
                </div>
                <div class="level-item">
                    <b-select v-if="objectTypeId > 0" v-model="objectId">
                        <option v-for="object in optionsForObjects"
                                :key="object.id"
                                :value="object.id"
                        >{{object.name}}</option>
                    </b-select>
                </div>
            </div>
        </div>
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <b-select v-model="timeFrameId">
                        <option v-for="timeFrame in optionsForTimeFrame"
                                :key="timeFrame.id"
                                :value="timeFrame.id"
                        >{{timeFrame.name}}</option>
                    </b-select>
                </div>
                <div class="level-item" v-if="timeFrameId === 9">
                    <b-datepicker
                            placeholder="Select interval..."
                            :min-date="minDate"
                            :max-date="maxDate"
                            v-model="intervalDates"
                            range
                    ></b-datepicker>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-button type="is-primary" v-if="objectId > 0" @click="handleClickChart" style="margin-right: 0.5rem;">Chart</b-button>
                    <b-button type="is-primary" :disabled="!validFilters()" @click="handleClick">See Events</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';
  import BSelect from "buefy/src/components/select/Select";
  import BDatepicker from "buefy/src/components/datepicker/Datepicker";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BDatepicker,
      BSelect
    },
    name: "events-filters",
    props: ['preselected', 'onSubmit'],
    data() {
      const today = new Date();

      return {
        preselectionDone: false,
        objectTypeId: 0,
        objectId: 0,
        timeFrameId: 7,
        minDate: new Date(Date.parse('2020-01-01')),
        maxDate: today,
        intervalDates: []
      };
    },
    watch: {
      objectTypeId() {
        if (this.preselectionDone) {
          this.objectId = 0;
        }
      }
    },
    computed: {
      ...mapGetters('objects', ['objectTypes', 'objectsByObjectType', 'chartTypeByObjectId']),
      ...mapGetters('events', ['timeFrames']),
      optionsForObjectTypes() {
        const ret = [
          {
            id: 0,
            name: '- any object type -'
          }
        ];

        this.objectTypes.forEach(item => {
          ret.push({...item});
        });

        return ret;
      },
      optionsForObjects() {
        if (this.objectTypeId === 0) {
          return [];
        }

        const ret = [{
          id: 0,
          name: '- any object -'
        }];

        this.objectsByObjectType(this.objectTypeId).forEach(item => {
          ret.push({...item});
        });

        return ret;
      },
      optionsForTimeFrame() {
        return this.timeFrames;
      }
    },
    methods: {
      ...mapMutations('ui', ['SHOW_OVERLAY', 'HIDE_OVERLAY']),
      validFilters() {
        return true;
      },
      handlePreselection() {
        const that = this;
        that['SHOW_OVERLAY']();
        if (this.preselected) {
          const that = this;

          const {objectTypeId, objectId, timeFrameId} = this.preselected;

          if (typeof objectTypeId !== 'undefined') {
            this.objectTypeId = objectTypeId;
          }
          if (typeof objectId !== 'undefined') {
            this.objectId = objectId;
          }
          if (typeof timeFrameId !== 'undefined') {
            this.timeFrameId = timeFrameId;
          }

          if (this.objectTypeId !== 0 || this.timeFrameId === 7 || this.timeFrameId === 8 || this.timeFrameId === 9) {
            that.handleClick();
          }

          setTimeout(() => {
            that.preselectionDone = true;
            that['HIDE_OVERLAY']();
          }, 600);
        }
      },
      handleClick() {
        if (typeof this.onSubmit === 'function') {
          this.onSubmit({
            objectTypeId: this.objectTypeId,
            objectId: this.objectId,
            timeFrameId: this.timeFrameId,
            intervalDates: this.intervalDates,
            orderDirection: -1,
            normalized: 1
          });
        }
      },
      handleClickChart() {
        const chartType = this.chartTypeByObjectId(this.objectId);
        switch (chartType) {
          case 'gantt':
            this.$router.push('/chart/gantt/' + this.objectId);
            break;
          default:
            this.$router.push('/chart/liniar/' + this.objectId);
            break;
        }
      }
    },
    mounted() {
      this.handlePreselection();
    }
  }
</script>

<style scoped>
    .container {
        padding-bottom: 1rem;
        border-bottom: dotted 1px #C9C9C9;
    }
</style>